import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsAgent } from '../../redux/userData'

function useTrackPageViews(isLoading = false) {
  const location = useLocation()
  const isAgent = useSelector(selectIsAgent)
  useEffect(() => {
    if (!isLoading) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'virtual_page_view',
        page: location.pathname,
        user_type: isAgent ? 'agent' : 'consumer',
      })
      // https://verbinteractive.atlassian.net/browse/VIT100-1797?focusedCommentId=789859
      window.dataLayer.push({
        event: 'user_type',
        page: location.pathname,
        user_type: isAgent ? 'agent' : 'consumer',
      })
    }
  }, [location.pathname, isAgent, isLoading])
}

export default useTrackPageViews
